
export class AlterarSenhaModel {

    public senhaAtual: string;

    constructor(public cpf: string,
                public senha: string,
                public confirmacaoSenha: string) {}
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-alterar-senha/alterar-senha.model.ts